export const _initialState = {
  dropZones: []
};
